import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from '../../ThemeContext';
import './Navbar.css';

export default function Navbar(props) {
  const { darkMode, toggleDarkMode } = useContext(ThemeContext);
  const [active_nav, set_active_nav] = useState(0);
  const [tline, set_tline] = useState(0);
  useEffect(() => {
    const sections = document.querySelectorAll('section');
    const sectionOptions = {
      root: null,
      threshold: 0.5,
    };
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Array.from(sections).indexOf(entry.target);
          set_active_nav(index);
          props.set_current_section(index)
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, sectionOptions);
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);
  const scrollToSection = (index) => {
    const sections = document.querySelectorAll('section');
    const targetSection = sections[index];

    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' });
      set_active_nav(index);
    }
  };

  function toggleTheme() {
    const body = document.querySelector("body");
    const moon = document.querySelector(".moon");
    const tdnn = document.querySelector(".tdnn");
    body.classList.toggle("light");
    moon.classList.toggle("sun");
    tdnn.classList.toggle("day");
    toggleDarkMode();
  }

  return (
    <div className="outer_nav">
      <div className={`section-navbar ${darkMode ? 'dark-mode' : ''}`}>
        <a href="/Home" className="logo">
          Ayush Kumawat<span>.</span>
        </a>
        <button className="tdnn" onClick={toggleTheme}>
          <div className="moon"></div>
        </button>
        <i onClick={() => set_tline(tline === 0 ? 1 : 0)} className="fa-solid fa-list"></i>
        <nav className="navbar">
          <a className={active_nav === 0 ? 'active' : ''} onClick={() => scrollToSection(0)}>
            HOME
          </a>
          <a className={active_nav === 1 ? 'active' : ''} onClick={() => scrollToSection(1)}>
            ABOUT ME
          </a>
          <a className={active_nav === 2 ? 'active' : ''} onClick={() => scrollToSection(2)}>
            INNOVATIONS
          </a>
          <a className={active_nav === 3 ? 'active' : ''} onClick={() => scrollToSection(3)}>
            DASHBOARD
          </a>
          <a className={active_nav === 4 ? 'active' : ''} onClick={() => scrollToSection(4)}>
            CONTACT
          </a>
        </nav>
      </div>
      <nav className={`navbar1 ${tline === 1 ? 'navbar1_active' : ''}`}>
        <a onClick={() => { scrollToSection(0); set_tline(tline === 0 ? 1 : 0); }} className={active_nav === 0 ? 'active btn' : 'btn'}>Home</a>
        <a onClick={() => { scrollToSection(1); set_tline(tline === 0 ? 1 : 0); }} className={active_nav === 1 ? 'active btn' : 'btn'}>About</a>
        <a onClick={() => { scrollToSection(2); set_tline(tline === 0 ? 1 : 0); }} className={active_nav === 2 ? 'active btn' : 'btn'}>Innovations</a>
        <a onClick={() => { scrollToSection(3); set_tline(tline === 0 ? 1 : 0); }} className={active_nav === 3 ? 'active btn' : 'btn'}>Dashboard</a>
        <a onClick={() => { scrollToSection(4); set_tline(tline === 0 ? 1 : 0); }} className={active_nav === 4 ? 'active btn' : 'btn'}>Contact</a>
      </nav>      
    </div>
  );
}